import React, { useState, useEffect } from "react";
import Creatable from "react-select/creatable";
import "./SelectInput.scss";

const createOption = (label) => ({
  label,
  value: label.toLowerCase().replace(/\W/g, ""),
});

const filterOption = (option, inputValue) => {
  if (!inputValue) return true;
  const search = inputValue.toLowerCase();
  return (
    option.label?.toLowerCase().includes(search) ||
    option.value?.toLowerCase().includes(search)
  );
};

const CreatableComponent = ({
  onChange,
  isMulti,
  placeholder,
  disabled,
  options,
  ...props
}) => {
  const [value, setValue] = useState();
  const [selectOptions, setSelectOptions] = useState([]);

  const handleChange = (selectedOption) => {
    setValue(selectedOption);
    if (selectedOption) {
      return onChange(selectedOption.value);
    }
    onChange(selectedOption);
  };

  const handleCreate = (inputValue) => {
    const newOption = createOption(inputValue);
    setValue(newOption);
    setSelectOptions((prevState) => [...prevState, newOption]);
  };

  useEffect(() => {
    if (props?.field?.value?.value) {
      setValue({
        label: props?.field?.value?.value,
        value: props?.field?.value?.value,
      });
    }
    setSelectOptions(options);
  }, []);

  return (
    <div className="selectize-div">
      <Creatable
        isClearable
        onChange={handleChange}
        onCreateOption={(newValue) => {
          handleCreate(newValue);
          onChange(newValue);
        }}
        options={selectOptions}
        onBlur={() => {}}
        value={value}
        placeholder={placeholder}
        isMulti={isMulti}
        isDisabled={disabled}
        filterOption={filterOption}
      />
    </div>
  );
};

export default CreatableComponent;
